import React from 'react'

import clsx from 'clsx'

import Category from 'components/Category'
import Tooltip from 'components/Tooltip'
import { EventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import clBadgeSVG from 'assets/category-leaders-header.svg'

import classes from './CategoryLeaders.module.scss'

/** @type {import("./types").default} */
const CategoryLeaders = ({ leaders }) => {
  const categoriesText = leaders.length > 1 ? 'categories' : 'category'
  const isMobile = useViewport().is('xs')

  return (
    <>
      <div className={classes.root}>
        {isMobile && (
          <Tooltip
            placement="top"
            title="Category Leaders rankings showcase the top 15 apps within a category, based on 5 key factors"
          >
            <span className={clsx(classes.categoryLeadersBadge)}>
              <img src={clBadgeSVG.src} alt="Getapp" width={154} />
            </span>
          </Tooltip>
        )}
        <div className={classes.container}>
          <div>
            <div className={classes.categoryLeadersContainer}>
              {!isMobile && (
                <Tooltip
                  placement="top"
                  title="Category Leaders rankings showcase the top 15 apps within a category, based on 5 key factors"
                >
                  <span className={classes.categoryLeadersBadge}>
                    <img src={clBadgeSVG.src} alt="Getapp" width={154} />
                  </span>
                </Tooltip>
              )}

              <EventContext
                value={{
                  engagementComponent: 'product_category-leaders',
                  engagementDestination: 'go-to_category_leaders',
                }}
              >
                {leaders.slice(0, 5).map(category => (
                  <Category.MiniCard
                    showCategoryLeader
                    category={category}
                    key={category.slug}
                    className={classes.category}
                    href={category.cta_urls.category_leaders}
                  />
                ))}
              </EventContext>
            </div>
          </div>
        </div>
      </div>

      {leaders.length > 5 && (
        <div className={classes.categoryLeadersText}>
          Awarded in{' '}
          <b>
            {leaders.length} {categoriesText}
          </b>{' '}
          in {new Date().getFullYear()}
        </div>
      )}
    </>
  )
}

export default CategoryLeaders
